import React, { useState, useEffect } from 'react';
import { ConnectWebSocketForOverlay, SetSocketMessageHandler, ClearSocketMessageHandler, DisconnectWebSocket } from '../../utilities/BL/Zones';
import { GetSettings } from '../../utilities/BL/OverlayQuizz';
import { OverlayQuizz as OverlayQuizzOverlay } from './Overlays/OverlayQuizz';

/**
 * COMPONENTE: OverlayQuizz OVERLAY (PARENT CONTAINER)
 * ------------------------------------------------------------------
 * Este componente es el "Cerebro" del Overlay.
 * 1. Establece la conexión WebSocket como "overlay:overlayquizz".
 * 2. Escucha los mensajes entrantes.
 * 3. Pasa la información al componente visual <OverlayQuizzOverlay />.
 * ------------------------------------------------------------------
 */
export function OverlayQuizz() {
    const [offsetY, setOffsetY] = useState(0);
    const [bannerMode, setBannerMode] = useState('invitation'); // invitation, winner
    const [winnerName, setWinnerName] = useState('');
    const [connectionStatus, setConnectionStatus] = useState('idle');

    // Visibility flowState (idle, entering, visible, fadingOut)
    const [flowState, setFlowState] = useState('idle');
    const [showConfetti, setShowConfetti] = useState(false);

    // 1. Force Transparent Background for OBS Overlay
    useEffect(() => {
        const originalBodyBg = document.body.style.backgroundColor;
        const originalHtmlBg = document.documentElement.style.backgroundColor;
        const rootElement = document.getElementById('root');

        document.body.style.backgroundColor = 'transparent';
        document.documentElement.style.backgroundColor = 'transparent';
        if (rootElement) {
            rootElement.style.backgroundColor = 'transparent';
        }

        return () => {
            document.body.style.backgroundColor = originalBodyBg;
            document.documentElement.style.backgroundColor = originalHtmlBg;
            if (rootElement) {
                rootElement.style.removeProperty('background-color');
            }
        };
    }, []);

    // 2. Control transitions (entering -> visible, fadingOut -> idle)
    useEffect(() => {
        let timeout;
        if (flowState === 'entering') {
            timeout = setTimeout(() => setFlowState('visible'), 500);
        } else if (flowState === 'fadingOut') {
            timeout = setTimeout(() => {
                setFlowState('idle');
                setShowConfetti(false);
            }, 500);
        }
        return () => clearTimeout(timeout);
    }, [flowState]);

    const handleOverlayVisibilityChange = (visible) => {
        if (visible) {
            setFlowState((prev) => {
                if (prev === 'idle' || prev === 'fadingOut') {
                    return 'entering';
                }
                return prev;
            });
        } else {
            setFlowState((prev) => {
                if (prev !== 'idle' && prev !== 'fadingOut') {
                    return 'fadingOut';
                }
                return prev;
            });
        }
    };

    // 3. Load Initial Settings and Connect WebSocket
    useEffect(() => {
        const init = async () => {
            const res = await GetSettings();
            if (res.success && res.data) {
                setOffsetY(res.data.offsetY);
                setBannerMode(res.data.bannerMode);
                setWinnerName(res.data.winnerName);
                
                if (res.data.isOverlayVisible) {
                    setFlowState('visible');
                    if (res.data.bannerMode === 'winner') {
                        setShowConfetti(true);
                    }
                } else {
                    setFlowState('idle');
                }
            }

            await ConnectWebSocketForOverlay(
                'overlayquizz',
                (status) => setConnectionStatus(status),
                (msg) => console.log('[OverlayQuizz] WS Toast:', msg)
            );

            SetSocketMessageHandler(handleIncomingMessage);
        };

        const handleIncomingMessage = (message) => {
            if (!message || !message.type) return;

            const type = message.type.toLowerCase();
            const data = message.data || message;

            if (type === 'config' || type === 'overlayquizz_config') {
                if (data.offsetY !== undefined) {
                    setOffsetY(data.offsetY);
                }
            } else if (type === 'state' || type === 'overlayquizz_state') {
                if (data.bannerMode) {
                    setBannerMode(data.bannerMode);
                    if (data.bannerMode === 'winner' && data.isOverlayVisible) {
                        setShowConfetti(true);
                    } else {
                        setShowConfetti(false);
                    }
                }
                if (data.winnerName !== undefined) {
                    setWinnerName(data.winnerName);
                }
                if (data.isOverlayVisible !== undefined) {
                    handleOverlayVisibilityChange(data.isOverlayVisible);
                }
            }
        };

        init();

        return () => {
            ClearSocketMessageHandler();
            DisconnectWebSocket();
        };
    }, []);

    return (
        <>
            <OverlayQuizzOverlay
                flowState={flowState}
                offsetY={offsetY}
                bannerMode={bannerMode}
                winnerName={winnerName}
                showConfetti={showConfetti}
            />

            {connectionStatus === 'error' && (
                <div style={{ position: 'fixed', bottom: 5, right: 5, background: 'red', color: 'white', padding: '3px 8px', fontSize: '9px', borderRadius: '4px', opacity: 0.8, zIndex: 99999 }}>
                    D
                </div>
            )}
        </>
    );
}

export default OverlayQuizz;
